module.exports = __webpack_public_path__ + "img/rtsp.240b64e6.svg";